import React from "react";

import PackageFlags from "./PackageFlags.jsx";
import PackageImage from "./PackageImage.jsx";

import { handleClick, venueLink } from "./helpers";

const PackageHeader = props => {
  const link = venueLink(props);

  return (
    <header data-href={link} onClick={handleClick("Image", link)}>
      <PackageFlags {...props} />
      <PackageImage {...props} />
    </header>
  );
};

export default PackageHeader;



// WEBPACK FOOTER //
// ./components/search/package/PackageHeader.jsx